<template>
  <Section :title="gettext('Année de construction du bâtiment')">
    <RadiosList
      :value="simulation.buildingDate"
      :field="field"
      @change="(val) => updateSimulation({ buildingDate: val.target.value })"
    >
      <template #default="slotProps">
        <div class="h5 mrgv0">{{ slotProps.choice[1] }}</div>
      </template>
    </RadiosList>
  </Section>
</template>

<script setup>
import { computed } from 'vue';
import Section from '@/components/simulation/Section.vue';
import RadiosList from '@/components/forms/fields/RadiosList.vue';
import { useSimulation } from '@/composables/useSimulation';

const { simulation, updateSimulation } = useSimulation();

const field = computed(() => {
  return {
    label: gettext('Quand le bâtiment a-t-il été construit?'),
    name: 'building-date',
    choices: [
      ['old', gettext('Avant 2000')],
      ['new', gettext('Après 2000')],
    ],
  };
});
</script>
